module.exports = __webpack_public_path__ + "media/categories/2045-ec3fe85a.svg";